import React from 'react'
import { Button, Card } from 'react-bootstrap'
import Switch from 'react-switch'
import currencyFormatter from 'currency-formatter'
import { FiCheck, FiPlus } from "react-icons/fi";
import '../../signup.scss'
import { SUPPORT_EMAIL_SIGNUP } from '../../constantStep';
import { FLEET_BILLING_MODE } from '../../../../containers/billingUsage/utils/constants';
import { I18n } from 'react-redux-i18n';

const plans = [
	{
		type: 'startup',
		name: 'Startup',
		features: [],
		operators: 1,
		drivers: 10,
		vehicles: 10,
		bookings: 'signup.unlimitedText',
		feePerBooking: '3.9%',
		isPopular: false
	},
	{
		type: 'pro',
		name: 'Pro',
		features: [],
		operators: 'signup.unlimitedText',
		drivers: 'signup.unlimitedText',
		vehicles: 'signup.unlimitedText',
		bookings: 'signup.unlimitedText',
		feePerBooking: '2.9%',
		isPopular: true
	},
	{
		type: 'vip',
		name: 'vip',
		features: [],
		operators: 'signup.unlimitedText',
		drivers: 'signup.unlimitedText',
		vehicles: 'signup.unlimitedText',
		bookings: 'signup.unlimitedText',
		feePerBooking: '2.9%',
		isPopular: false
	},
	{
		type: 'enterprise',
		name: 'ENTERPRISE',
		monthlyPrice: 'Custom',
		annualPrice: 'Custom',
		features: [{
			icon: 'plus',
			text: 'signup.planFeatures.plusEverythingInPro'
		},
		{
			icon: 'checked',
			text: 'signup.planFeatures.tierDiscountPricing'
		},
		{
			icon: 'checked',
			text: 'signup.planFeatures.customFeatureDevelopment'
		}],
		operators: 'signup.unlimitedText',
		drivers: 'signup.unlimitedText',
		vehicles: 'signup.unlimitedText',
		bookings: 'signup.unlimitedText',
		feePerBooking: 'signup.volumeDiscount',
		isPopular: false,
		buttonText: 'signup.letsTalkButton',
		disabled: true,
	}
]

const PlanContainer = ({
	pricingConfigs,
	onSubmit,
	billingPlanFleetSelected,
	queryLocation,
	disabledSwitchBtn: disabledSwitchBtnProps,
	...props
}) => {
	const [billingPeriod, setBillingPeriod] = React.useState('monthly')
	const [isMobile, setIsMobile] = React.useState(false)
	const [focusedPlan, setFocusedPlan] = React.useState(null)
	const [infoPlans, setInfoPlans] = React.useState(null)
	// Check if device is mobile
	React.useEffect(() => {
		const checkMobile = () => {
			setIsMobile(window.innerWidth < 768)
		}
		checkMobile()
		window.addEventListener('resize', checkMobile)

		return () => window.removeEventListener('resize', checkMobile)
	}, [])

	React.useEffect(() => {
		const infoPlans = getInfoPlan(pricingConfigs)
		setInfoPlans(infoPlans || [])
		if (billingPlanFleetSelected?.planId) {
			setFocusedPlan(infoPlans.find(plan => plan._id === billingPlanFleetSelected?.planId))
			setBillingPeriod(billingPlanFleetSelected?.billingType)
		} else {
			if(queryLocation?.plan) {
				const findPlanOnLocation = infoPlans.find(plan => plan._id === queryLocation?.plan)
				if(findPlanOnLocation) {
					setFocusedPlan(findPlanOnLocation)
					if(['monthly', 'annual'].includes(queryLocation?.type)) {
						setBillingPeriod(queryLocation?.type)
					}
				}
				return;
			}
			if (infoPlans?.[1]) {
				setFocusedPlan(infoPlans[1])
			} else {
				if (props.isCustomPlan) {
					if (infoPlans?.[0]?.customPlanType?.annual) {
						setBillingPeriod('annual')
					}
					if (infoPlans?.[0]?.customPlanType?.monthly) {
						setBillingPeriod('monthly')
					}
				}
				setFocusedPlan(infoPlans[0])
			}
		}
	}, [billingPlanFleetSelected])


	const formatPrice = (price) => {
		return price === 'Custom' ? 'Custom' : `$${price}`
	}

	const getButtonText = (defaultText, plan) => {
		if(plan?._id && billingPlanFleetSelected?.planId && billingPeriod !== billingPlanFleetSelected?.billingType) {
			return I18n.t('signup.upgrade')
		}
		return I18n.t(defaultText)
	}

	const getInfoPlan = () => {
		let pricingConfigsSorted = pricingConfigs?.sort((a, b) => {
			const feeA = a.pricingConfigs.find(item => item.type === 'monthly')?.fee || 0;
			const feeB = b.pricingConfigs.find(item => item.type === 'monthly')?.fee || 0;
			return feeA - feeB;
		});
		pricingConfigsSorted = (pricingConfigsSorted || []).slice(0, 3);
		const planResult = []
		plans?.map((plan, index) => {
			const valueSetting = pricingConfigsSorted?.[index]
			if(valueSetting || (index === 3 && !props.isCustomPlan)) {
				planResult.push({
					...plan,
					...valueSetting,
					monthlyPrice: valueSetting?.pricingConfigs?.find(p => p.type === 'monthly')?.fee ?? formatPrice(plan.monthlyPrice),
					annualPrice: valueSetting?.pricingConfigs?.find(p => p.type === 'annual')?.fee ?? formatPrice(plan.annualPrice),
					name: valueSetting?.planName ?? plan.name,
					currencyISO: valueSetting?.currencyISO ?? plan.currencyISO,
					_id: valueSetting?._id ?? plan._id,
					buttonText: valueSetting?.buttonText || plan.buttonText,
					disabled: valueSetting?.disabled || plan.disabled || false,
					description: index === 3 ? I18n.t('signup.planDescriptions.enterprise') : valueSetting?.description,
				})
			}
		})
		return planResult
	}

	const handleSubmitPlan = (plan, billingType) => {
		if (
			plan?.billingMode === FLEET_BILLING_MODE.invoice ||
			plan?.type === 'enterprise'
		) {
			window.open(`mailto:${SUPPORT_EMAIL_SIGNUP}`, '_blank');
		} else {
			onSubmit(plan._id, billingType)
		}
	}

	const calculateSavePercentage = () => {
		if (focusedPlan?.monthlyPrice === 0 || focusedPlan?.annualPrice === 0) {
			return 0;
		}
		return Math.round((((focusedPlan?.monthlyPrice * 12) - focusedPlan?.annualPrice) / (focusedPlan?.monthlyPrice * 12)) * 100);
	}

	// const converFeaturesToText = (feature, item) => {
	// 	if(feature.type === 'feePerBooking') {
	// 		const bookingTiers = item?.usageConfigs?.[0]?.[billingPeriod]?.bookingTiers?.[0]
	// 		let valueFee = ''
	// 		const amountType = item?.usageConfigs?.[0]?.usageType
	// 		if(amountType !== "block") {
	// 			if(amountType === 'percent') {
	// 				valueFee = `${bookingTiers?.feeAmount || 0}%`
	// 			} else {
	// 				valueFee = currencyFormatter.format(bookingTiers?.feeAmount || 0, { code: item?.currencyISO })
	// 			}
	// 		}
	// 		if(valueFee) return I18n.t('signup.planFeatures.feePerBooking').format(valueFee)
	// 		return ''
	// 	}
	// 	return I18n.t(feature.text)
	// }

	const getFreeBookingPerMonth = (item) => {
		const bookingAllowance = item?.usageConfigs?.[0]?.[billingPeriod]?.allowance || 0
		if(bookingAllowance > 0) {
			return I18n.t('signup.planFeatures.freeBookingPerMonth').format(bookingAllowance)
		}
		return ''
	}

	const getFeePerBooking = (item) => {
		const usageType = item?.usageConfigs?.[0]?.usageType
		const bookingTiers = item?.usageConfigs?.[0]?.[billingPeriod]?.bookingTiers?.[0]
		let valueFee = ''
		if(usageType !== "block") {
			if(usageType === 'percent') {
				valueFee = `${bookingTiers?.feeAmount || 0}%`
			} else if(usageType === 'fixed') {
				valueFee = currencyFormatter.format(bookingTiers?.feeAmount || 0, { code: item?.currencyISO })
			}
		}
		if(valueFee) return I18n.t('signup.planFeatures.feePerBooking').format(valueFee)
		return ''
	}

	const showDiscounted = (pricingConfig, currencyISO) => {
		if(pricingConfig?.fee === 0 && pricingConfig?.oneTimeFee === 0) {
			return I18n.t('signup.waived')
		}
		if(pricingConfig?.fee > 0 && pricingConfig?.oneTimeFee === 0) {
			return I18n.t('signup.discounted')
		}
		if(pricingConfig?.oneTimeFee > 0) {
			return currencyFormatter.format(pricingConfig?.oneTimeFee, { code: currencyISO })
		}
		return ''
	}

	const getOneTimeSetupFee = (item) => {
		const pricingConfig = item?.pricingConfigs?.find(p => p.type === billingPeriod)
		if(_.isNumber(pricingConfig?.oneTimeFee)) {
			return (
				<p className="one-time-setup-fee" style={{ borderTop: '1px solid #e5e7eb', paddingTop: 15, marginTop: 15, display: 'flex', alignItems: 'center' }}>
					<b style={{ fontSize: '1.125rem', fontWeight: 600, marginRight: '8px' }}>{showDiscounted(pricingConfig, item?.currencyISO)}</b>
					<span>{I18n.t('signup.oneTimeSetupFee')}</span>
				</p>
			)
		}
		return ''
	}

	const getCustomFees = (item) => {
		return (
			<div>
				{
					item.customFees.map((fee) => {
						return (
							<p className="one-time-setup-fee" style={{ display: 'flex', alignItems: 'center' }}>
								<b style={{ fontSize: '1.125rem', fontWeight: 600, marginRight: '8px' }}>{currencyFormatter.format(fee.fee, { code: item?.currencyISO })}</b>
								<span>{fee.name}</span>
							</p>
						)
					})
				}
			</div>
		)
	}

	const getLimitation = (item) => {
		return ['operator', 'driver', 'vehicle'].map(key => {
			let value = item.limitation[key]
			if (typeof item.limitation[key] !== 'number') {
				value = 'Unlimited'
			}

			return (
				<div className="feature-item">
					<span className="feature-icon"><FiCheck size={16} /></span>
					<span className="feature-text">{value} {I18n.t(`signup.limitation.${value > 1 ? key + 's' : key}`)}</span>
				</div>
			)
		})
	}

	const getCustomPlanFeatures = () => {
		return ['tierDiscountPricing', 'customFeatureDevelopment', 'unlimitedOperators', 'unlimitedDrivers', 'unlimitedVehicles'].map(feature => {
			return (
				<div className="feature-item">
					<span className="feature-icon"><FiCheck size={16} /></span>
					<span className="feature-text">{I18n.t('signup.planFeatures.' + feature)}</span>
				</div>
			)
		})
	}

	return (
		<div className='plan-step'>
			<Card className="card-signup-step">
				<Card.Body>
					<Card.Title style={{ textAlign: 'center', marginBottom: 20 }}>{I18n.t(props.isCustomPlan ? 'signup.stepPlanCustom' : 'signup.stepPlanTitle')}</Card.Title>
					<p className='plan-description-container' style={{ textAlign: 'center', marginBottom: 20 }}>{props.title || I18n.t(props.isCustomPlan ? 'signup.planDescriptionCustom' : 'signup.planDescription')}</p>
					{/* Billing Toggle */}
					{(!props.isCustomPlan 
						  || ( props.isCustomPlan 
						  		&& focusedPlan?.customPlanType?.monthly
								&& focusedPlan?.customPlanType?.annual
							)
						) && <div className="billing-toggle-container mb-4">
						{isMobile ? (
							// Mobile toggle (current implementation)
							<div className="billing-toggle">
								<button
									type="button"
									className={`toggle-btn ${billingPeriod === 'monthly' ? 'active' : ''}`}
									onClick={() => setBillingPeriod('monthly')}
									disabled={focusedPlan?.disabledSwitchBtn || disabledSwitchBtnProps}
								>
									{I18n.t('signup.billingMonthly')}
								</button>
								<button
									type="button"
									className={`toggle-btn ${billingPeriod === 'annual' ? 'active' : ''}`}
									onClick={() => setBillingPeriod('annual')}
									disabled={focusedPlan?.disabledSwitchBtn || disabledSwitchBtnProps}
								>
									{I18n.t('signup.billingAnnual')}
									{/* <span className="save-badge">{I18n.t('signup.saveBadge')}</span> */}
									{
										calculateSavePercentage() > 0 && (
											<span className="" style={{ color: '#12B76A', marginLeft: 3 }}>{`(${calculateSavePercentage()}%)`}</span>
										)
									}
								</button>
							</div>
						) : (
							// Desktop Switch
							 <div className="billing-switch">
								<span className={`period-label ${billingPeriod === 'monthly' ? 'active' : ''}`}>
									{I18n.t('signup.billingMonthly')}
								</span>
								<Switch
									checked={billingPeriod === 'annual'}
									onChange={(checked) => setBillingPeriod(checked ? 'annual' : 'monthly')}
									offColor="#e5e7eb"
									onColor="#16a34a"
									offHandleColor="#ffffff"
									onHandleColor="#ffffff"
									handleDiameter={20}
									uncheckedIcon={false}
									checkedIcon={false}
									height={24}
									width={48}
									className="billing-switch-component"
									disabled={focusedPlan?.disabledSwitchBtn || disabledSwitchBtnProps}
								/>
								<span className={`period-label ${billingPeriod === 'annual' ? 'active' : ''}`}>
									{I18n.t('signup.billingAnnual')}
									{
										calculateSavePercentage() > 0 && (
											<span className="save-badge-switch">{I18n.t('signup.savePercentage').format(calculateSavePercentage())}</span>
										)
									}
								</span>
							</div>
						)}
					</div>}

					{/* Plan Cards */}
					<div className={`plans-container ${props.isCustomPlan ? 'custom-plan-container' : ''}`}>
						{infoPlans?.map((plan, index) => {
							return (
							<div
								key={plan.type}
								className={`plan-card ${focusedPlan?.type ?
									focusedPlan?.type === plan.type ? 'focused' : ''
									: index === 1 ? 'popular' : ''
									}`
								}
								style={{
									cursor: plan.disabledAll ? 'not-allowed' : 'pointer',
								}}
								onClick={() => {
									if (plan.disabledAll) {
										return;
									}
									setFocusedPlan(plan)
								}}
							>
								{plan.isPopular && <div className="popular-badge">{I18n.t('signup.popularBadge')}</div>}
								<div className="plan-header">
									<h3 className="plan-name text-left">{plan.name}</h3>
									{
										plan.type === 'enterprise' ? (
											<div className="plan-price text-left">
												<div className="d-flex align-items-center justify-content-start" style={{ lineHeight: 1, margin: '5px 0' }}>
													<span style={{ fontWeight: 500, fontSize: 32, marginRight: 10 }}>{I18n.t('signup.customPricing')}</span>
												</div>
											</div>
										) : (
											<div className="plan-price text-left">
												<div className="d-flex align-items-center justify-content-start" style={{ lineHeight: 1, margin: '5px 0' }}>
													<span style={{ fontWeight: 500, fontSize: 32, marginRight: 10 }}>{currencyFormatter.format(billingPeriod === 'monthly' ? plan.monthlyPrice : plan.annualPrice, { code: plan?.currencyISO })}</span>
													<div>
														<span className="font-weight-500" style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 5 }}>
															{plan?.currencyISO}
														</span>
														<span style={{ fontSize: 12, fontWeight: 500, display: 'block' }}>{`/${billingPeriod === 'annual' ? I18n.t('signup.periodAnnual') : I18n.t('signup.periodMonthly')}`}</span>
													</div>
												</div>
											</div>
										)
									}
									<p className="plan-description">{plan.description}</p>
									<div className="d-flex align-items-center justify-content-start flex-wrap">
										{/* {
											getFreeBookingPerMonth(plan) &&
											<div className="bonus-credits">{getFreeBookingPerMonth(plan)}</div>
										} */}
										{
											plan.creditGrants?.[0]?.oneTimeAmount > 0 &&
											<div className="bonus-credits">{I18n.t('signup.bonusCredits').format(currencyFormatter.format(plan.creditGrants?.[0]?.oneTimeAmount, { code: plan?.currencyISO }))}</div>
										}
									</div>
								</div>
								<div className="plan-features">
									{
										getFreeBookingPerMonth(plan) && (
											<div className="feature-item">
												<span className="feature-icon"><FiCheck size={16} /></span>
												<span className="feature-text"><b>{getFreeBookingPerMonth(plan)}</b></span>
											</div>
										)
									}
									{
										getFeePerBooking(plan) && (
											<div className="feature-item">
												<span className="feature-icon"><FiCheck size={16} /></span>
												<span className="feature-text">{getFeePerBooking(plan)}</span>
											</div>
										)
									}
									{
										plan.limitation && (
											getLimitation(plan)
										)
									}
									{
										getOneTimeSetupFee(plan)
									}
									{
										plan.type === 'enterprise' && getCustomPlanFeatures(plan)
									}
									{
										props?.isCustomPlan && plan.customFees?.length > 0 && getCustomFees(plan)
									}
								</div>
								<div className="plan-footer">
									{
										plan.buttonText && (
											<Button
												className={`select-plan-btn ${focusedPlan?.type === plan.type ? 'focused-btn' : ''}`}
												onClick={() => handleSubmitPlan(plan, billingPeriod)}
											>
												{getButtonText(plan.buttonText, plan)}
											</Button>
										)
									}
								</div>
							</div>
						)})}
					</div>
					<div>
					  {I18n.t('signup.limitedNotes')}
					</div>
				</Card.Body>
			</Card>
		</div>
	)
}

export default PlanContainer